import { IHomeClubReview } from '../interfaces/INewFeed';
import { IHomeClubReviewListData } from '../interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import HomeClubReview from './homeClubReview';
import { Comment } from './clubVoteComments';
import { IContentItemHomeClubReview, IHomeClubReviewList } from 'redhotpie-shared-lib/interfaces/ICommunity';
import Owner from './owner';

export default class HomeClubReviewList {
  approvalState?: string;
  classification?: number;
  clubVisibility?: string;
  eventInterestExpressed?: boolean;
  isMemberLike?: boolean;
  itemList?: IContentItemHomeClubReview[];
  mediaCount?: number;
  parentType?: string;

  constructor() {
    this.approvalState = '';
    this.classification = 0;
    this.clubVisibility = '';
    this.eventInterestExpressed = false;
    this.isMemberLike = false;
    this.itemList = [];
    this.mediaCount = 0;
    this.parentType = '';
  }

  static mappingObject(_obj: IHomeClubReviewListData): IHomeClubReviewList {
    let obj = Object.assign(new HomeClubReviewList(), _obj);
    (obj.approvalState = _obj.ApprovalState),
      (obj.classification = _obj.Classification),
      (obj.clubVisibility = _obj.ClubVisibility),
      (obj.eventInterestExpressed = _obj.EventInterestExpressed),
      (obj.isMemberLike = _obj.IsMemberLike),
      (obj.itemList = _obj.ItemList ? HomeClubReviewList.mappingItemList(_obj.ItemList) : []),
      (obj.mediaCount = _obj.MediaCount),
      (obj.parentType = _obj.ParentType),
      (obj = utils.cleanObjectKeys(Object.keys(new HomeClubReviewList()), obj));
    return obj;
  }

  static mappingItem(_obj: IHomeClubReview): IContentItemHomeClubReview {
    return HomeClubReview.mappingObject(_obj);
  }

  static mappingItemList(_obj: IHomeClubReview[]): IContentItemHomeClubReview[] {
    return _obj.map(item => HomeClubReviewList.mappingItem(item));
  }

  static mapAllReviewList(_obj: any): IContentItemHomeClubReview[] {
    return _obj.map((item: any) => ({
      clubId: item.Club.ClubID,
      clubImg: item.Club.Banner.FullUrl,
      clubName: item.Club.ClubName,
      description: item.Comment.Message,
      dateCreated: item.Comment.DateCreated,
      owner: Owner.mappingObject(item.Comment.Profile),
    }));
  }
}
